exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".header{border-bottom:1px solid #eaeaea!important;background-image:url(" + require("assets/img/grumpy.png") + ");background-position:top;background-repeat:no-repeat;background-size:130px 100px}.brand.inline{padding-left:50px}.brand.brand.inline,body.menu-behind .header .brand{width:300px}.profile-dropdown{margin-right:100px}.sidebar-width{width:280px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-1e625b13","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/navbar.vue
// module id = 1259
// module chunks = 1